module.exports = __webpack_public_path__ + "img/cptx5@2x.b5b3d585.png";